module.exports = __webpack_public_path__ + "ring-classic.51558efbab6bd9745f63.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/assets/img/ring-classic.svg
// module id = ../../../../../src/assets/img/ring-classic.svg
// module chunks = main